import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import asyncComponent from "util/asyncComponent";

const Members = ({match}) => (
  <Switch>
    <Route path={`${match.url}`} component={asyncComponent(() => import('../../components/Members/MemberTable'))}/>
  </Switch>
);

export default Members;
